import React, { useContext } from "react";

import history from "./utils/history";
import Context from "./utils/context";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import "assets/scss/xrs.scss";
// pages for this product
import WellcomePage from "views/WellcomePage/WellcomePage.js";
import DocumentsPage from "views/DocumentsPage/DocumentsPage.js";

import ViewAccountPage from "views/ViewAccountPage/ViewAccountPage.js";
import CreatePayment from "views/CreatePaymentPage/CreatePaymentPlanPage.js";
import LandingPage from "views/LandingPage/LandingPage.js";
import LandingPageCreateUser from "views/LandingPage/LandingPageCreateUser.js";
import QuickPayPage from "views/QuickPayPage/QuickPayPage.js";
import QuickPayPaymentStatus from "views/QuickPayPage/QuickPayPaymentStatus.js";
import PayNowPaymentStatus from "views/PayNowPage/PayNowPaymentStatus.js";
import PayNowPage from "views/PayNowPage/PayNowPage.js";
import ViewOfferPage from "views/ViewOfferPage/ViewOfferPage.js";
import FaqPage from "views/FaqPage/FaqPage.js";
import BudgetPage from "views/BudgetPage/BudgetPage.js";
import RequestCallBackPage from "views/RequestCallBackPage/RequestCallBackPageLoggendIn.js";
import ChangePassword from "views/ChangePassworOrPin/ChangePasswordOrPinPage.js";
import FaqPageLogin from "views/FaqPageLogin/FaqPageLogin.js";
import IframePage from "views/IframePage/IframePage";

import MessagesPage from "views/MessagesPage/MessagesPage.js";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/welcome" element={<WellcomePage />} />
      <Route path="/documents" element={<DocumentsPage />} />

      <Route path="/createPayment" element={<CreatePayment />} />
      <Route
        path="/quickpay-paymentstatus"
        element={<QuickPayPaymentStatus />}
      />

      <Route path="/paynow-paymentstatus" element={<PayNowPaymentStatus />} />
      <Route path="/faq" element={<FaqPageLogin />} />
      <Route path="/messages" element={<MessagesPage />} />
      <Route path="/payNow" element={<PayNowPage />} />
      <Route path="/iframe" element={<IframePage />} />

      <Route
        path="/changePassword"
        element={<ChangePassword cred="password" />}
      />
      <Route path="/changePin" element={<ChangePassword cred="pin" />} />

      <Route path="/viewaccount" element={<ViewAccountPage />} />
      <Route path="/budgetPage" element={<BudgetPage />} />
      <Route path="/createUser" element={<LandingPageCreateUser />} />

      <Route path="/landing-page" element={<LandingPage cred="false" />} />

      <Route path="/CreateAccount" element={<LandingPage create="true" />} />

      <Route path="/quickpay-page" element={<QuickPayPage />} />

      <Route path="/requestcallback-page" element={<RequestCallBackPage />} />
      <Route path="/faq-page" element={<FaqPage />} />
      <Route path="/viewOffer" element={<ViewOfferPage />} />

      <Route path="/" element={<LandingPage create="false" />} />
    </Routes>
  );
};
export default AppRoutes;
